import { useEffect } from "react";

const RedirectPage = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_HOMEPAGE_URL}/product_l3_sarcopenia_ai`;
  }, []);

  return null; // 아무것도 렌더링하지 않음
};

export default RedirectPage;